import React, { useEffect } from "react";
import Navigation from "../Navigation";
import "./style.scss";
import { useNavigate } from "react-router";
import useTicketManager from "./useTicketManager";
import { TicketModel } from "../../models/TicketModel";
import { Assort } from "../../models/Assort";
import Ticket from "./Ticket";
import getId from "../../../utils/getId";
import ReturnButton from "../../../features/ReturnButton";
import { EXERCISE_PAGE, FINALIZE_PAGE, ZONES_PAGE } from "../../routes";
import LeftContainer from "./LeftContainer";
import useBasketManager from "../Basket/useBasketManager";
import LoadableComponent from "../../../features/Loading/LoadableComponent";
import useTypeSale from "../../../utils/hooks/useTypeSale";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import { viewCart } from "../../ga4/gaMethods";
// import { getCalculateBottom } from "../../../utils/getCalculateBottom";

const TicketsPage: React.FC = () => {
  const navigate = useNavigate();
  const isDesktop = useDesktopSize();
  const { isSaleWithExercise, backgroundClass, colorClass, isChangeZone, categoryBrand } = useTypeSale();

  const { loading: loadingTicket, tickets, assorts } = useTicketManager(isSaleWithExercise);
  const { basket, setBasket, addToBasket, removeBasket, totalListPrice, removeWholeBasket } = useBasketManager(
    isSaleWithExercise,
    assorts,
    isChangeZone
  );

  const navigateToFinalize = () => {
    if (isSaleWithExercise) {
      navigate(`${EXERCISE_PAGE}?isSaleWithExercise=${isSaleWithExercise}`);
    } else {
      viewCart(basket, categoryBrand, totalListPrice);
      navigate(`${FINALIZE_PAGE}?isSaleWithExercise=${isSaleWithExercise}`);
    }
  };

  const finalizeButtonText = isSaleWithExercise ? "Przejdź do wyboru dnia" : "Przejdź do podsumowania";

  // useEffect(() => {
  //   if (!isDesktop) {
  //     getCalculateBottom("basket-panel", "ticketPanel");
  //   }
  // }, [basket, isDesktop]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Navigation>
      <div className={"sale-panel"}>
        <div className={"tickets-panel"} id={"ticketPanel"}>
          <p className={"title"}>Wybierz bilet</p>
          {tickets.map((item: TicketModel, index: number) => (
            <LoadableComponent loading={loadingTicket} key={index}>
              {item.assorts.length > 0 && (
                <>
                  <p className={`ticket-group ${backgroundClass}`}>{item.title}</p>
                  <div className={"ticket-wrapper"}>
                    {item.assorts.map((assort: Assort) => (
                      <Ticket
                        key={getId(assort)}
                        colorClass={colorClass}
                        ticket={assort}
                        onAddToBasket={addToBasket}
                        onRemoveToBasket={removeBasket}
                        basket={basket}
                        isSaleWithExercise={isSaleWithExercise}
                      />
                    ))}
                  </div>
                </>
              )}
            </LoadableComponent>
          ))}
          {isDesktop && <ReturnButton onClick={() => navigate(ZONES_PAGE)} />}
        </div>
        <LeftContainer
          colorClass={colorClass}
          basket={basket}
          onRemoveToBasket={removeWholeBasket}
          updateBasket={setBasket}
          onNavigateFinalize={navigateToFinalize}
          finalizeButtonText={finalizeButtonText}
          isSaleWithExercise={isSaleWithExercise}
          totalListPrice={totalListPrice}
        />
      </div>
    </Navigation>
  );
};

export default TicketsPage;
